module.exports = __webpack_public_path__ + "static/media/profileIconUnselected.65253f51.png";